import React, { useState, useEffect } from 'react'
import { DataTable, Button } from '@paypalcorp/pp-react'
import { TextInputWrapper } from '../../../components/pp-react-wrappers'
import Fuse from 'fuse.js'
import CardBrandCell from './CardBrandTableFormats/CardBrandCell'
import CodeCurrencyFormat from './CardBrandTableFormats/CodeCurrencyFormat'
import CountryCell from './CardBrandTableFormats/CountryCell'
import CurrenciesCell from './CardBrandTableFormats/CurrenciesCell'
import SpecialCurrencyFormat from './CardBrandTableFormats/SpecialCurrencyFormat'

// SearchableTableACDCNotCollapsed holds the content for ACDC country, currency, and card brand updates.

// For the GA/public version of ACDC's currency table, declare the object TableACDC_GA,
// or declare the SearchableTableACDCNotCollapsed object,
// and include the following in the declaration:
// searchable={true}
// rowDataName="card_supported_currencies_acdc_focus_row"
// colDataName="card_supported_currencies_acdc_focus_column"
// searchKeys={['country.value', 'country.countryCode']}

// For the limited-release version of ACDC's currency table, declare the object TableACDC_limited_release,
// or declare the SearchableTableACDCNotCollapsed object,
// and include the following in the declaration:
// searchable={true}
// rowDataName="card_supported_currencies_full_focus_row"
// colDataName="card_supported_currencies_full_focus_column"
// searchKeys={['currencyCode.value', 'currencyName.value']}

const cardSupportedCurrenciesACDC_Focus_Rows = [
  {
    id: 'row1',
    country: { value: 'Australia', countryCode: 'AU' },
    cardBrand: {
      value: [
        'Mastercard',
        'Visa',
        <span key="american express">
          American Express (<code>AUD</code> only)
        </span>,
        <span key="american express">
          eftpos (<code>AUD</code> only)
        </span>,
      ],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row2',
    country: { value: 'Austria', countryCode: 'AT' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row3',
    country: { value: 'Belgium', countryCode: 'BE' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row4',
    country: { value: 'Bulgaria', countryCode: 'BG' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row5',
    country: { value: 'Canada', countryCode: 'CA' },
    cardBrand: {
      value: [
        'Mastercard',
        'Visa',
        <span key="american express">
          American Express (<code>CAD</code> and <code>USD</code> only)
        </span>,
        <span key="jcb">
          JCB (<code>CAD</code> only)
        </span>,
      ],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row6',
    country: { value: 'China', countryCode: 'CN' },
    cardBrand: {
      value: ['Mastercard', 'Visa'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row7',
    country: { value: 'Cyprus', countryCode: 'CY' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row8',
    country: { value: 'Czech Republic', countryCode: 'CZ' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row9',
    country: { value: 'Denmark', countryCode: 'DK' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row10',
    country: { value: 'Estonia', countryCode: 'EE' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row11',
    country: { value: 'Finland', countryCode: 'FI' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row12',
    country: { value: 'France', countryCode: 'FR' },
    cardBrand: {
      value: [
        'Mastercard',
        'Visa',
        'American Express',
        <span key="carte bancaire">
          Carte Bancaire (<code>EUR</code> only)
        </span>,
      ],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row13',
    country: { value: 'Germany', countryCode: 'DE' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row14',
    country: { value: 'Greece', countryCode: 'GR' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row15',
    country: { value: 'Hong Kong', countryCode: 'HK' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row16',
    country: { value: 'Hungary', countryCode: 'HU' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row17',
    country: { value: 'Ireland', countryCode: 'IE' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row18',
    country: { value: 'Italy', countryCode: 'IT' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row19',
    country: { value: 'Japan', countryCode: 'JP' },
    cardBrand: {
      value: [
        'Mastercard',
        'Visa',
        <span key="american express">
          American Express (<code>AUD</code>, <code>CAD</code>, <code>CHF</code>
          , <code>CZK</code>, <code>DKK</code>, <code>EUR</code>,{' '}
          <code>GBP</code>, <code>HKD</code>, <code>HUF</code>, <code>JPY</code>
          , <code>NOK</code>, <code>NZD</code>, <code>PLN</code>,{' '}
          <code>SEK</code>, <code>SGD</code>, and <code>USD</code> only)
        </span>,
        <span key="jcb">
          JCB (<code>JPY</code> only)
        </span>,
        'Diners',
      ],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row20',
    country: { value: 'Latvia', countryCode: 'LV' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row21',
    country: { value: 'Liechtenstein', countryCode: 'LI' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row22',
    country: { value: 'Lithuania', countryCode: 'LT' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row23',
    country: { value: 'Luxembourg', countryCode: 'LU' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row24',
    country: { value: 'Malta', countryCode: 'MT' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row25',
    country: { value: 'Mexico', countryCode: 'MX' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [{ value: 'MXN' }],
    },
  },
  {
    id: 'row26',
    country: { value: 'Netherlands', countryCode: 'NL' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row27',
    country: { value: 'Norway', countryCode: 'NO' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row28',
    country: { value: 'Poland', countryCode: 'PL' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row29',
    country: { value: 'Portugal', countryCode: 'PT' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row30',
    country: { value: 'Romania', countryCode: 'RO' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row31',
    country: { value: 'Singapore', countryCode: 'SG' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row32',
    country: { value: 'Slovakia', countryCode: 'SK' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row33',
    country: { value: 'Slovenia', countryCode: 'SI' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row34',
    country: { value: 'Spain', countryCode: 'ES' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row35',
    country: { value: 'Sweden', countryCode: 'SE' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row36',
    country: { value: 'United Kingdom', countryCode: 'GB' },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'BRL' },
        { value: 'CAD' },
        { value: 'CHF' },
        { value: 'CZK' },
        { value: 'DKK' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'HKD' },
        { value: 'HUF' },
        { value: 'ILS' },
        { value: 'JPY', footnote: '0' },
        { value: 'MXN' },
        { value: 'NOK' },
        { value: 'NZD' },
        { value: 'PHP' },
        { value: 'PLN' },
        { value: 'SEK' },
        { value: 'SGD' },
        { value: 'THB' },
        { value: 'TWD', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
  {
    id: 'row37',
    country: { value: 'United States', countryCode: 'US' },
    cardBrand: {
      value: [
        'Mastercard',
        'Visa',
        <span key="american express©">
          American Express (<code>USD</code> only)
        </span>,
        <span key="discover">
          Discover (<code>USD</code> only)
        </span>,
        'Debit networks (Star/Star Access, Pulse, Nyce, Accel)',
      ],
    },
    currencies: {
      value: [
        { value: 'AUD' },
        { value: 'CAD' },
        { value: 'EUR' },
        { value: 'GBP' },
        { value: 'JPY', footnote: '0' },
        { value: 'USD' },
      ],
    },
  },
]

const cardSupportedCurrenciesACDC_Focus_Columns = {
  country: {
    title: 'Country',
    cellAs: CountryCell,
    width: '10%',
    mobile: {
      placement: 'a12',
      width: 'auto',
    },
  },
  cardBrand: {
    title: 'Card brand',
    cellAs: CardBrandCell,
    width: '15%',
    mobile: {
      placement: 'b3',
    },
  },
  currencies: {
    title: 'Currencies',
    cellAs: CurrenciesCell,
    width: '20%',
    mobile: {
      placement: 'b3',
    },
  },
}

const cardSupportedCurrenciesFull_Focus_Rows = [
  {
    id: 'row1',
    currencyCode: { value: 'AFN' },
    currencyName: { value: 'Afghan Afghani' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row2',
    currencyCode: { value: 'ALL' },
    currencyName: { value: 'Albanian Lek' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row3',
    currencyCode: { value: 'DZD' },
    currencyName: { value: 'Algerian Dinar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row4',
    currencyCode: { value: 'AOA' },
    currencyName: { value: 'Angolan Kwanza' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row5',
    currencyCode: { value: 'ARS' },
    currencyName: { value: 'Argentine Peso' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row6',
    currencyCode: { value: 'AMD' },
    currencyName: { value: 'Armenian Dram' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row7',
    currencyCode: { value: 'AWG' },
    currencyName: { value: 'Aruban Florin' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row8',
    currencyCode: { value: 'AUD' },
    currencyName: { value: 'Australian Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row9',
    currencyCode: { value: 'AZN' },
    currencyName: { value: 'Azerbaijani Manat' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row10',
    currencyCode: { value: 'BSD' },
    currencyName: { value: 'Bahamian Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row11',
    currencyCode: { value: 'BHD', footnote: '3' },
    currencyName: { value: 'Bahraini Dinar' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row12',
    currencyCode: { value: 'BDT' },
    currencyName: { value: 'Bangladeshi Taka' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row13',
    currencyCode: { value: 'BBD' },
    currencyName: { value: 'Barbadian Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row14',
    currencyCode: { value: 'BZD' },
    currencyName: { value: 'Belizean Dollar' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row15',
    currencyCode: { value: 'BMD' },
    currencyName: { value: 'Bermudian Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row16',
    currencyCode: { value: 'BTN' },
    currencyName: { value: 'Bhutanese Ngultrum' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row17',
    currencyCode: { value: 'BOB' },
    currencyName: { value: 'Bolivian Boliviano' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row18',
    currencyCode: { value: 'BAM' },
    currencyName: { value: 'Bosnia-Herzegovina Convertible Mark' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row19',
    currencyCode: { value: 'BWP' },
    currencyName: { value: 'Botswana Pula' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row20',
    currencyCode: { value: 'BRL' },
    currencyName: { value: 'Brazilian Real' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row21',
    currencyCode: { value: 'GBP' },
    currencyName: { value: 'British Pound' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row22',
    currencyCode: { value: 'BND' },
    currencyName: { value: 'Bruneian Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row23',
    currencyCode: { value: 'BGN' },
    currencyName: { value: 'Bulgarian Lev' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row24',
    currencyCode: { value: 'BIF', footnote: '0' },
    currencyName: { value: 'Burundi Franc' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row25',
    currencyCode: { value: 'KHR' },
    currencyName: { value: 'Cambodian Riel' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row26',
    currencyCode: { value: 'CAD' },
    currencyName: { value: 'Canadian Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: 'JCB' },
  },
  {
    id: 'row27',
    currencyCode: { value: 'CVE' },
    currencyName: { value: 'Cape Verdean Escudo' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row28',
    currencyCode: { value: 'KYD' },
    currencyName: { value: 'Caymanian Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row29',
    currencyCode: { value: 'XAF', footnote: '0' },
    currencyName: { value: 'Central African CFA Franc' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row30',
    currencyCode: { value: 'XPF', footnote: '0' },
    currencyName: { value: 'CFP Franc' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row31',
    currencyCode: { value: 'CLP', footnote: '0' },
    currencyName: { value: 'Chilean Peso' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row32',
    currencyCode: { value: 'COP', footnote: '0' },
    currencyName: { value: 'Colombian Peso' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row33',
    currencyCode: { value: 'KMF', footnote: '0' },
    currencyName: { value: 'Comoran Franc' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row34',
    currencyCode: { value: 'CDF' },
    currencyName: { value: 'Congolese Frank' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row35',
    currencyCode: { value: 'CRC', footnote: '0' },
    currencyName: { value: 'Costa Rican Colon' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row36',
    currencyCode: { value: 'CZK' },
    currencyName: { value: 'Czech Koruna' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row37',
    currencyCode: { value: 'DKK' },
    currencyName: { value: 'Danish Krone' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row38',
    currencyCode: { value: 'DJF', footnote: '0' },
    currencyName: { value: 'Djiboutian Franc' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row39',
    currencyCode: { value: 'DOP' },
    currencyName: { value: 'Dominican Peso' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row40',
    currencyCode: { value: 'XCD' },
    currencyName: { value: 'East Caribbean Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row41',
    currencyCode: { value: 'EGP' },
    currencyName: { value: 'Egyptian Pound' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row42',
    currencyCode: { value: 'ERN' },
    currencyName: { value: 'Eritrean Nakfa' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row43',
    currencyCode: { value: 'ETB' },
    currencyName: { value: 'Ethiopian Birr' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row44',
    currencyCode: { value: 'EUR' },
    currencyName: { value: 'Euro' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row45',
    currencyCode: { value: 'FKP' },
    currencyName: { value: 'Falkland Pound' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row46',
    currencyCode: { value: 'FJD' },
    currencyName: { value: 'Fijian Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row47',
    currencyCode: { value: 'GMD' },
    currencyName: { value: 'Gambian Dalasi' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row48',
    currencyCode: { value: 'GEL' },
    currencyName: { value: 'Georgian Lari' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row49',
    currencyCode: { value: 'GHS' },
    currencyName: { value: 'Ghana Cedi' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row50',
    currencyCode: { value: 'GIP' },
    currencyName: { value: 'Gibraltar Pound' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row51',
    currencyCode: { value: 'GTQ' },
    currencyName: { value: 'Guatemalan Quetzal' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row52',
    currencyCode: { value: 'GNF', footnote: '0' },
    currencyName: { value: 'Guinean Franc' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row53',
    currencyCode: { value: 'GYD' },
    currencyName: { value: 'Guyanaese Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row54',
    currencyCode: { value: 'HTG' },
    currencyName: { value: 'Haitian Gourde' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row55',
    currencyCode: { value: 'HNL' },
    currencyName: { value: 'Honduran Lempira' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row56',
    currencyCode: { value: 'HKD' },
    currencyName: { value: 'Hong Kong Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row57',
    currencyCode: { value: 'HUF' },
    currencyName: { value: 'Hungarian Forint' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row58',
    currencyCode: { value: 'ISK', footnote: '0' },
    currencyName: { value: 'Icelandic Krona' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row59',
    currencyCode: { value: 'INR' },
    currencyName: { value: 'Indian Rupee' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row60',
    currencyCode: { value: 'IDR' },
    currencyName: { value: 'Indonesian Rupiah' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row61',
    currencyCode: { value: 'ILS' },
    currencyName: { value: 'Israeli New Shekel' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row62',
    currencyCode: { value: 'JMD' },
    currencyName: { value: 'Jamaican Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row63',
    currencyCode: { value: 'JPY', footnote: '0' },
    currencyName: { value: 'Japanese Yen' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: 'JCB' },
  },
  {
    id: 'row64',
    currencyCode: { value: 'JOD', footnote: '3' },
    currencyName: { value: 'Jordanian Dinar' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row65',
    currencyCode: { value: 'KZT' },
    currencyName: { value: 'Kazakhstani Tenge' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row66',
    currencyCode: { value: 'KES' },
    currencyName: { value: 'Kenyan Shilling' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row67',
    currencyCode: { value: 'KWD', footnote: '3' },
    currencyName: { value: 'Kuwaiti Dinar' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row68',
    currencyCode: { value: 'KGS' },
    currencyName: { value: 'Kyrgyzstani Som' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row69',
    currencyCode: { value: 'LAK' },
    currencyName: { value: 'Lao Kip' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row70',
    currencyCode: { value: 'LBP' },
    currencyName: { value: 'Lebanese Pound' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row71',
    currencyCode: { value: 'LSL' },
    currencyName: { value: 'Lesotho Loti' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row72',
    currencyCode: { value: 'LRD' },
    currencyName: { value: 'Liberian Dollar' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row73',
    currencyCode: { value: 'MOP' },
    currencyName: { value: 'Macanese Pataca' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row74',
    currencyCode: { value: 'MKD' },
    currencyName: { value: 'Macedonian Denar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row75',
    currencyCode: { value: 'MGA', footnote: '2' },
    currencyName: {
      value: 'Malagasy Ariary',
      anchortag: '#link-malagasyariary',
    },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row76',
    currencyCode: { value: 'MWK' },
    currencyName: { value: 'Malawian Kwacha' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row77',
    currencyCode: { value: 'MVR' },
    currencyName: { value: 'Maldivian Rufiyaa' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row78',
    currencyCode: { value: 'MRO' },
    currencyName: { value: 'Mauritanian Ouguiya' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row79',
    currencyCode: { value: 'MRU' },
    currencyName: { value: 'Mauritanian Ouguiya' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row80',
    currencyCode: { value: 'MUR' },
    currencyName: { value: 'Mauritian Rupee' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row81',
    currencyCode: { value: 'MXN' },
    currencyName: { value: 'Mexican Peso' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row82',
    currencyCode: { value: 'MDL' },
    currencyName: { value: 'Moldovan Leu' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row83',
    currencyCode: { value: 'MNT' },
    currencyName: { value: 'Mongolian Tugrik' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row84',
    currencyCode: { value: 'MAD' },
    currencyName: { value: 'Moroccan Dirham' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row85',
    currencyCode: { value: 'MZN' },
    currencyName: { value: 'Mozambican Metical' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row86',
    currencyCode: { value: 'MMK' },
    currencyName: { value: 'Myanmar Kyat' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row87',
    currencyCode: { value: 'NAD' },
    currencyName: { value: 'Namibian Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row88',
    currencyCode: { value: 'NPR' },
    currencyName: { value: 'Nepalese Rupee' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row89',
    currencyCode: { value: 'ANG' },
    currencyName: { value: 'Netherlands Antillean Guilder' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row90',
    currencyCode: { value: 'TWD', footnote: '0' },
    currencyName: { value: 'New Taiwan Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row91',
    currencyCode: { value: 'NZD' },
    currencyName: { value: 'New Zealand Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row92',
    currencyCode: { value: 'NIO' },
    currencyName: { value: 'Nicaraguan Cordoba Oro' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row93',
    currencyCode: { value: 'NGN' },
    currencyName: { value: 'Nigerian Naira' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row94',
    currencyCode: { value: 'NOK' },
    currencyName: { value: 'Norwegian Krone' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row95',
    currencyCode: { value: 'OMR', footnote: '3' },
    currencyName: { value: 'Omani Sul Rial' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row96',
    currencyCode: { value: 'PKR' },
    currencyName: { value: 'Pakistani Rupee' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row97',
    currencyCode: { value: 'PAB' },
    currencyName: { value: 'Panamanian Balboa' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row98',
    currencyCode: { value: 'PGK' },
    currencyName: { value: 'Papua New Guinean Kina' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row99',
    currencyCode: { value: 'PYG', footnote: '0' },
    currencyName: { value: 'Paraguayan Guarani' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row100',
    currencyCode: { value: 'PEN' },
    currencyName: { value: 'Peruvian Nuevo Sol' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row101',
    currencyCode: { value: 'PHP' },
    currencyName: { value: 'Philippine Peso' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row102',
    currencyCode: { value: 'PLN' },
    currencyName: { value: 'Polish Zloty' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row103',
    currencyCode: { value: 'QAR' },
    currencyName: { value: 'Qatari Riyal' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row104',
    currencyCode: { value: 'RON' },
    currencyName: { value: 'Romanian Leu' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row105',
    currencyCode: { value: 'RUB' },
    currencyName: { value: 'Russian Ruble' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row106',
    currencyCode: { value: 'RWF', footnote: '0' },
    currencyName: { value: 'Rwanda Franc' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row107',
    currencyCode: { value: 'SHP' },
    currencyName: { value: 'Saint Helena Pound' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row108',
    currencyCode: { value: 'SVC' },
    currencyName: { value: 'Salvadoran Colon' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row109',
    currencyCode: { value: 'WST' },
    currencyName: { value: 'Samoan Tala' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row110',
    currencyCode: { value: 'STN' },
    currencyName: { value: 'São Tomé and Príncipe Dobra' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row111',
    currencyCode: { value: 'SAR' },
    currencyName: { value: 'Saudi Riyal' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row112',
    currencyCode: { value: 'RSD' },
    currencyName: { value: 'Serbian Dinar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row113',
    currencyCode: { value: 'SCR' },
    currencyName: { value: 'Seychellois Rupee' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row114',
    currencyCode: { value: 'SLE' },
    currencyName: { value: 'Sierra Leonean Leone' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row115',
    currencyCode: { value: 'SLL' },
    currencyName: { value: 'Sierra Leonean Leone' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row116',
    currencyCode: { value: 'SGD' },
    currencyName: { value: 'Singapore Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row117',
    currencyCode: { value: 'SBD' },
    currencyName: { value: 'Solomon Islands Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row118',
    currencyCode: { value: 'SOS', footnote: '0' },
    currencyName: { value: 'Somali Shilling' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row119',
    currencyCode: { value: 'ZAR' },
    currencyName: { value: 'South African Rand' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row120',
    currencyCode: { value: 'KRW', footnote: '0' },
    currencyName: { value: 'South Korean Won' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row121',
    currencyCode: { value: 'LKR' },
    currencyName: { value: 'Sri Lankan Rupee' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row122',
    currencyCode: { value: 'SRD' },
    currencyName: { value: 'Surinamese Guilder' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row123',
    currencyCode: { value: 'SZL' },
    currencyName: { value: 'Swazi Lilangeni' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row124',
    currencyCode: { value: 'SEK' },
    currencyName: { value: 'Swedish Krona' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row125',
    currencyCode: { value: 'CHF' },
    currencyName: { value: 'Swiss Franc' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row126',
    currencyCode: { value: 'TJS' },
    currencyName: { value: 'Tajikistan Ruble' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row127',
    currencyCode: { value: 'TZS', footnote: '0' },
    currencyName: { value: 'Tanzanian Shilling' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row128',
    currencyCode: { value: 'THB' },
    currencyName: { value: 'Thai Baht' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row129',
    currencyCode: { value: 'TOP' },
    currencyName: { value: 'Tongan Paʻanga' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row130',
    currencyCode: { value: 'TTD' },
    currencyName: { value: 'Trinidad and Tobago Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row131',
    currencyCode: { value: 'TND', footnote: '3' },
    currencyName: { value: 'Tunisian Dinar' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row132',
    currencyCode: { value: 'TMT' },
    currencyName: { value: 'Turkmenistan Manat' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row133',
    currencyCode: { value: 'UGX', footnote: '0' },
    currencyName: { value: 'Ugandan Shilling' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row134',
    currencyCode: { value: 'UAH' },
    currencyName: { value: 'Ukrainian Hryvnia' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row135',
    currencyCode: { value: 'AED' },
    currencyName: { value: 'United Arab Emirates Dirham' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row136',
    currencyCode: { value: 'UYU' },
    currencyName: { value: 'Uruguayan Peso' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row137',
    currencyCode: { value: 'USD' },
    currencyName: { value: 'US Dollar' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row138',
    currencyCode: { value: 'UZS' },
    currencyName: { value: 'Uzbekistani Som' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row139',
    currencyCode: { value: 'VUV', footnote: '0' },
    currencyName: { value: 'Vanuatu Vatu' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row140',
    currencyCode: { value: 'VES' },
    currencyName: { value: 'Venezuelan Bolivar' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'N' },
    supportLocal: { value: '' },
  },
  {
    id: 'row141',
    currencyCode: { value: 'VND', footnote: '0' },
    currencyName: { value: 'Vietnamese Dong' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row142',
    currencyCode: { value: 'XOF', footnote: '0' },
    currencyName: { value: 'West African CFA Franc' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row143',
    currencyCode: { value: 'YER' },
    currencyName: { value: 'Yemeni Rial' },
    supportVMC: { value: 'Y' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
  {
    id: 'row144',
    currencyCode: { value: 'ZMW' },
    currencyName: { value: 'Zambian Kwacha' },
    supportVMC: { value: 'N' },
    supportAmex: { value: 'Y' },
    supportLocal: { value: '' },
  },
]

const cardSupportedCurrenciesFull_Focus_Columns = {
  currencyCode: {
    title: 'Currency',
    cellAs: CodeCurrencyFormat,
    mobile: {
      placement: 'a12',
      width: 'auto',
    },
  },
  currencyName: {
    title: 'Name',
    cellAs: SpecialCurrencyFormat,
    mobile: {
      placement: 'b3',
    },
  },
  supportVMC: {
    title: 'V/MC',
    mobile: {
      placement: 'b3',
    },
  },
  supportAmex: {
    title: 'Amex',
    mobile: {
      placement: 'b3',
    },
  },
  supportLocal: {
    title: 'Local',
    mobile: {
      placement: 'b3',
    },
  },
}

const cardSupportedCurrenciesBrandedLR_Focus_Rows = [
  {
    id: 'row1',
    currencyCode: { value: 'AFN' },
    currencyName: { value: 'Afghan Afghani' },
  },
  {
    id: 'row2',
    currencyCode: { value: 'ALL' },
    currencyName: { value: 'Albanian Lek' },
  },
  {
    id: 'row3',
    currencyCode: { value: 'DZD' },
    currencyName: { value: 'Algerian Dinar' },
  },
  {
    id: 'row4',
    currencyCode: { value: 'AOA' },
    currencyName: { value: 'Angolan Kwanza' },
  },
  {
    id: 'row5',
    currencyCode: { value: 'AMD' },
    currencyName: { value: 'Armenian Dram' },
  },
  {
    id: 'row6',
    currencyCode: { value: 'AWG' },
    currencyName: { value: 'Aruban Florin' },
  },
  {
    id: 'row7',
    currencyCode: { value: 'AZN' },
    currencyName: { value: 'Azerbaijani Manat' },
  },
  {
    id: 'row8',
    currencyCode: { value: 'BSD' },
    currencyName: { value: 'Bahamian Dollar' },
  },
  {
    id: 'row9',
    currencyCode: { value: 'BHD', footnote: '3' },
    currencyName: { value: 'Bahraini Dinar' },
  },
  {
    id: 'row10',
    currencyCode: { value: 'BDT' },
    currencyName: { value: 'Bangladeshi Taka' },
  },
  {
    id: 'row11',
    currencyCode: { value: 'BBD' },
    currencyName: { value: 'Barbadian Dollar' },
  },
  {
    id: 'row12',
    currencyCode: { value: 'BZD' },
    currencyName: { value: 'Belize Dollar' },
  },
  {
    id: 'row13',
    currencyCode: { value: 'BMD' },
    currencyName: { value: 'Bermudian Dollar' },
  },
  {
    id: 'row14',
    currencyCode: { value: 'BTN' },
    currencyName: { value: 'Bhutanese Ngultrum' },
  },
  {
    id: 'row15',
    currencyCode: { value: 'BOB' },
    currencyName: { value: 'Bolivian Boliviano' },
  },
  {
    id: 'row16',
    currencyCode: { value: 'BAM' },
    currencyName: { value: 'Bosnia-Herzegovina Convertible Mark' },
  },
  {
    id: 'row17',
    currencyCode: { value: 'BWP' },
    currencyName: { value: 'Botswana Pula' },
  },
  {
    id: 'row18',
    currencyCode: { value: 'BND' },
    currencyName: { value: 'Bruneian Dollar' },
  },
  {
    id: 'row19',
    currencyCode: { value: 'BGN' },
    currencyName: { value: 'Bulgarian Lev' },
  },
  {
    id: 'row20',
    currencyCode: { value: 'BIF', footnote: '0' },
    currencyName: { value: 'Burundi Franc' },
  },
  {
    id: 'row21',
    currencyCode: { value: 'KHR' },
    currencyName: { value: 'Cambodian Riel' },
  },
  {
    id: 'row22',
    currencyCode: { value: 'CVE' },
    currencyName: { value: 'Cape Verdean Escudo' },
  },
  {
    id: 'row23',
    currencyCode: { value: 'KYD' },
    currencyName: { value: 'Caymanian Dollar' },
  },
  {
    id: 'row24',
    currencyCode: { value: 'XAF', footnote: '0' },
    currencyName: { value: 'Central African CFA Franc' },
  },
  {
    id: 'row25',
    currencyCode: { value: 'XPF', footnote: '0' },
    currencyName: { value: 'CFP Franc' },
  },
  {
    id: 'row26',
    currencyCode: { value: 'CLP', footnote: '0' },
    currencyName: { value: 'Chilean Peso' },
  },
  {
    id: 'row27',
    currencyCode: { value: 'COP', footnote: '0' },
    currencyName: { value: 'Colombian Peso' },
  },
  {
    id: 'row28',
    currencyCode: { value: 'KMF', footnote: '0' },
    currencyName: { value: 'Comoran Franc' },
  },
  {
    id: 'row29',
    currencyCode: { value: 'CDF' },
    currencyName: { value: 'Congolese Frank' },
  },
  {
    id: 'row30',
    currencyCode: { value: 'CRC', footnote: '0' },
    currencyName: { value: 'Costa Rican Colon' },
  },
  {
    id: 'row31',
    currencyCode: { value: 'DJF', footnote: '0' },
    currencyName: { value: 'Djiboutian Franc' },
  },
  {
    id: 'row32',
    currencyCode: { value: 'DOP' },
    currencyName: { value: 'Dominican Peso' },
  },
  {
    id: 'row33',
    currencyCode: { value: 'XCD' },
    currencyName: { value: 'East Caribbean Dollar' },
  },
  {
    id: 'row34',
    currencyCode: { value: 'EGP' },
    currencyName: { value: 'Egyptian Pound' },
  },
  {
    id: 'row35',
    currencyCode: { value: 'ERN' },
    currencyName: { value: 'Eritrean Nakfa' },
  },
  {
    id: 'row36',
    currencyCode: { value: 'ETB' },
    currencyName: { value: 'Ethiopian Birr' },
  },
  {
    id: 'row37',
    currencyCode: { value: 'FKP' },
    currencyName: { value: 'Falkland Pound' },
  },
  {
    id: 'row38',
    currencyCode: { value: 'FJD' },
    currencyName: { value: 'Fijian Dollar' },
  },
  {
    id: 'row39',
    currencyCode: { value: 'GMD' },
    currencyName: { value: 'Gambian Dalasi' },
  },
  {
    id: 'row40',
    currencyCode: { value: 'GEL' },
    currencyName: { value: 'Georgian Lari' },
  },
  {
    id: 'row41',
    currencyCode: { value: 'GHS' },
    currencyName: { value: 'Ghanaian Cedi' },
  },
  {
    id: 'row42',
    currencyCode: { value: 'GIP' },
    currencyName: { value: 'Gibraltar Pound' },
  },
  {
    id: 'row43',
    currencyCode: { value: 'GTQ' },
    currencyName: { value: 'Guatemalan Quetzal' },
  },
  {
    id: 'row44',
    currencyCode: { value: 'GNF', footnote: '0' },
    currencyName: { value: 'Guinean Franc' },
  },
  {
    id: 'row45',
    currencyCode: { value: 'GYD' },
    currencyName: { value: 'Guyanaese Dollar' },
  },
  {
    id: 'row46',
    currencyCode: { value: 'HTG' },
    currencyName: { value: 'Haitian Gourde' },
  },
  {
    id: 'row47',
    currencyCode: { value: 'HNL' },
    currencyName: { value: 'Honduran Lempira' },
  },
  {
    id: 'row48',
    currencyCode: { value: 'ISK', footnote: '0' },
    currencyName: { value: 'Icelandic Krona' },
  },
  {
    id: 'row49',
    currencyCode: { value: 'IDR' },
    currencyName: { value: 'Indonesian Rupiah' },
  },
  {
    id: 'row50',
    currencyCode: { value: 'JMD' },
    currencyName: { value: 'Jamaican Dollar' },
  },
  {
    id: 'row51',
    currencyCode: { value: 'JOD', footnote: '3' },
    currencyName: { value: 'Jordanian Dinar' },
  },
  {
    id: 'row52',
    currencyCode: { value: 'KZT' },
    currencyName: { value: 'Kazakhstani Tenge' },
  },
  {
    id: 'row53',
    currencyCode: { value: 'KES' },
    currencyName: { value: 'Kenyan Shilling' },
  },
  {
    id: 'row54',
    currencyCode: { value: 'KWD', footnote: '3' },
    currencyName: { value: 'Kuwaiti Dinar' },
  },
  {
    id: 'row55',
    currencyCode: { value: 'KGS' },
    currencyName: { value: 'Kyrgyzstani Som' },
  },
  {
    id: 'row56',
    currencyCode: { value: 'LAK' },
    currencyName: { value: 'Lao Kip' },
  },
  {
    id: 'row57',
    currencyCode: { value: 'LSL' },
    currencyName: { value: 'Lesotho Loti' },
  },
  {
    id: 'row58',
    currencyCode: { value: 'LRD' },
    currencyName: { value: 'Liberian Dollar' },
  },
  {
    id: 'row59',
    currencyCode: { value: 'MOP' },
    currencyName: { value: 'Macanese Pataca' },
  },
  {
    id: 'row60',
    currencyCode: { value: 'MKD' },
    currencyName: { value: 'Macedonian Denar' },
  },
  {
    id: 'row61',
    currencyCode: { value: 'MGA', footnote: '2' },
    currencyName: {
      value: 'Malagasy Ariary',
      anchortag: '#link-malagasyariary',
    },
  },
  {
    id: 'row62',
    currencyCode: { value: 'MWK' },
    currencyName: { value: 'Malawian Kwacha' },
  },
  {
    id: 'row63',
    currencyCode: { value: 'MVR' },
    currencyName: { value: 'Maldivian Rufiyaa' },
  },
  {
    id: 'row64',
    currencyCode: { value: 'MRU' },
    currencyName: { value: 'Mauritanian Ouguiya' },
  },
  {
    id: 'row65',
    currencyCode: { value: 'MUR' },
    currencyName: { value: 'Mauritian Rupee' },
  },
  {
    id: 'row66',
    currencyCode: { value: 'MDL' },
    currencyName: { value: 'Moldovan Leu' },
  },
  {
    id: 'row67',
    currencyCode: { value: 'MNT' },
    currencyName: { value: 'Mongolian Tugrik' },
  },
  {
    id: 'row68',
    currencyCode: { value: 'MAD' },
    currencyName: { value: 'Moroccan Dirham' },
  },
  {
    id: 'row69',
    currencyCode: { value: 'MZN' },
    currencyName: { value: 'Mozambican Metical' },
  },
  {
    id: 'row70',
    currencyCode: { value: 'MMK' },
    currencyName: { value: 'Myanmar Kyat' },
  },
  {
    id: 'row71',
    currencyCode: { value: 'NAD' },
    currencyName: { value: 'Namibian Dollar' },
  },
  {
    id: 'row72',
    currencyCode: { value: 'NPR' },
    currencyName: { value: 'Nepalese Rupee' },
  },
  {
    id: 'row73',
    currencyCode: { value: 'ANG' },
    currencyName: { value: 'Netherlands Antillean Guilder' },
  },
  {
    id: 'row74',
    currencyCode: { value: 'NIO' },
    currencyName: { value: 'Nicaraguan Cordoba Oro' },
  },
  {
    id: 'row75',
    currencyCode: { value: 'NGN' },
    currencyName: { value: 'Nigerian Naira' },
  },
  {
    id: 'row76',
    currencyCode: { value: 'OMR', footnote: '3' },
    currencyName: { value: 'Omani Rial' },
  },
  {
    id: 'row77',
    currencyCode: { value: 'PKR' },
    currencyName: { value: 'Pakistani Rupee' },
  },
  {
    id: 'row78',
    currencyCode: { value: 'PAB' },
    currencyName: { value: 'Panamanian Balboa' },
  },
  {
    id: 'row79',
    currencyCode: { value: 'PGK' },
    currencyName: { value: 'Papua New Guinean Kina' },
  },
  {
    id: 'row80',
    currencyCode: { value: 'PYG', footnote: '0' },
    currencyName: { value: 'Paraguayan Guarani' },
  },
  {
    id: 'row81',
    currencyCode: { value: 'PEN' },
    currencyName: { value: 'Peruvian Nuevo Sol' },
  },
  {
    id: 'row82',
    currencyCode: { value: 'QAR' },
    currencyName: { value: 'Qatari Riyal' },
  },
  {
    id: 'row83',
    currencyCode: { value: 'RON' },
    currencyName: { value: 'Romanian Leu' },
  },
  {
    id: 'row84',
    currencyCode: { value: 'RWF', footnote: '0' },
    currencyName: { value: 'Rwandan Franc' },
  },
  {
    id: 'row85',
    currencyCode: { value: 'SHP' },
    currencyName: { value: 'Saint Helena Pound' },
  },
  {
    id: 'row86',
    currencyCode: { value: 'SVC' },
    currencyName: { value: 'Salvadoran Colon' },
  },
  {
    id: 'row87',
    currencyCode: { value: 'WST' },
    currencyName: { value: 'Samoan Tala' },
  },
  {
    id: 'row88',
    currencyCode: { value: 'STN' },
    currencyName: { value: 'São Toméan Dobra' },
  },
  {
    id: 'row89',
    currencyCode: { value: 'SAR' },
    currencyName: { value: 'Saudi Riyal' },
  },
  {
    id: 'row90',
    currencyCode: { value: 'RSD' },
    currencyName: { value: 'Serbian Dinar' },
  },
  {
    id: 'row91',
    currencyCode: { value: 'SCR' },
    currencyName: { value: 'Seychellois Rupee' },
  },
  {
    id: 'row92',
    currencyCode: { value: 'SLE' },
    currencyName: { value: 'Sierra Leonean Leone' },
  },
  {
    id: 'row93',
    currencyCode: { value: 'SBD' },
    currencyName: { value: 'Solomon Islands Dollar' },
  },
  {
    id: 'row94',
    currencyCode: { value: 'SOS', footnote: '0' },
    currencyName: { value: 'Somali Shilling' },
  },
  {
    id: 'row95',
    currencyCode: { value: 'ZAR' },
    currencyName: { value: 'South African Rand' },
  },
  {
    id: 'row96',
    currencyCode: { value: 'KRW', footnote: '0' },
    currencyName: { value: 'South Korean Won' },
  },
  {
    id: 'row97',
    currencyCode: { value: 'LKR' },
    currencyName: { value: 'Sri Lankan Rupee' },
  },
  {
    id: 'row98',
    currencyCode: { value: 'SRD' },
    currencyName: { value: 'Surinamese Guilder' },
  },
  {
    id: 'row99',
    currencyCode: { value: 'SZL' },
    currencyName: { value: 'Swazi Lilangeni' },
  },
  {
    id: 'row100',
    currencyCode: { value: 'TJS' },
    currencyName: { value: 'Tajikistan Ruble' },
  },
  {
    id: 'row101',
    currencyCode: { value: 'TZS', footnote: '0' },
    currencyName: { value: 'Tanzanian Shilling' },
  },
  {
    id: 'row102',
    currencyCode: { value: 'TOP' },
    currencyName: { value: 'Tongan Paʻanga' },
  },
  {
    id: 'row103',
    currencyCode: { value: 'TTD' },
    currencyName: { value: 'Trinidad and Tobago Dollar' },
  },
  {
    id: 'row104',
    currencyCode: { value: 'TND', footnote: '3' },
    currencyName: { value: 'Tunisian Dinar' },
  },
  {
    id: 'row105',
    currencyCode: { value: 'TMT' },
    currencyName: { value: 'Turkmenistani Manat' },
  },
  {
    id: 'row106',
    currencyCode: { value: 'UGX', footnote: '0' },
    currencyName: { value: 'Ugandan Shilling' },
  },
  {
    id: 'row107',
    currencyCode: { value: 'UAH' },
    currencyName: { value: 'Ukrainian Hryvnia' },
  },
  {
    id: 'row108',
    currencyCode: { value: 'AED' },
    currencyName: { value: 'United Arab Emirates Dirham' },
  },
  {
    id: 'row109',
    currencyCode: { value: 'UYU' },
    currencyName: { value: 'Uruguayan Peso' },
  },
  {
    id: 'row110',
    currencyCode: { value: 'UZS' },
    currencyName: { value: 'Uzbekistani Som' },
  },
  {
    id: 'row111',
    currencyCode: { value: 'VUV', footnote: '0' },
    currencyName: { value: 'Vanuatu Vatu' },
  },
  {
    id: 'row112',
    currencyCode: { value: 'VES' },
    currencyName: { value: 'Venezuelan Bolivar' },
  },
  {
    id: 'row113',
    currencyCode: { value: 'VND', footnote: '0' },
    currencyName: { value: 'Vietnamese Dong' },
  },
  {
    id: 'row114',
    currencyCode: { value: 'XOF', footnote: '0' },
    currencyName: { value: 'West African CFA Franc' },
  },
  {
    id: 'row115',
    currencyCode: { value: 'YER' },
    currencyName: { value: 'Yemeni Rial' },
  },
  {
    id: 'row116',
    currencyCode: { value: 'ZMW' },
    currencyName: { value: 'Zambian Kwacha' },
  },
]

const cardSupportedCurrenciesBrandedLR_Focus_Columns = {
  currencyName: {
    title: 'Currency',
    cellAs: SpecialCurrencyFormat,
    mobile: {
      placement: 'a12',
      width: 'auto',
    },
  },
  currencyCode: {
    title: 'Code',
    cellAs: CodeCurrencyFormat,
    mobile: {
      placement: 'b3',
    },
  },
}

interface ISearchableTable {
  rowDataName: string
  colDataName: string
  searchKeys?: string[]
  searchable?: boolean
}

const lookupRow = {
  card_supported_currencies_full_focus_row:
    cardSupportedCurrenciesFull_Focus_Rows,
  card_supported_currencies_acdc_focus_row:
    cardSupportedCurrenciesACDC_Focus_Rows,
  card_supported_currencies_branded_lr_focus_row:
    cardSupportedCurrenciesBrandedLR_Focus_Rows,
}

const lookupCol = {
  card_supported_currencies_full_focus_column:
    cardSupportedCurrenciesFull_Focus_Columns,
  card_supported_currencies_acdc_focus_column:
    cardSupportedCurrenciesACDC_Focus_Columns,
  card_supported_currencies_branded_lr_focus_column:
    cardSupportedCurrenciesBrandedLR_Focus_Columns,
}

const SearchableTableACDCNotCollapsed = ({
  rowDataName,
  colDataName,
  searchKeys = [],
  searchable = false,
}: ISearchableTable) => {
  const allRows = lookupRow[rowDataName]
  const columns = lookupCol[colDataName]
  const [rows, setRows] = useState(allRows)
  const options = {
    threshold: 0.4,
    keys: searchKeys,
  }
  const fuse = new Fuse(allRows, options)
  const [isLoading, setLoading] = useState(false)
  const [searchInput, setSearchInput] = useState('')
  const showSeeMoreBtn = rows.length < allRows.length
  const [filteredRows, setFilteredRows] = useState(allRows)

  useEffect(() => {
    if (searchInput) {
      setFilteredRows(fuse.search(searchInput).map(({ item }) => item))
    } else {
      setFilteredRows(allRows)
    }
  }, [searchInput, allRows, fuse])

  const handleTextChange = (e) => {
    setSearchInput(e.target.value)
  }

  const handleSeeMore = () => {
    setSearchInput('')
    setLoading(true)
    setTimeout(() => {
      setRows((currRowsShown) => allRows.slice(0, currRowsShown.length + 5))
      setLoading(false)
    }, 300)
  }

  return (
    <>
      {searchable && (
        <TextInputWrapper
          nameValue="basic"
          errorPresent={false}
          errorTextForFpti=""
          name="basic"
          value={searchInput}
          label="Search table"
          labelClassName="test"
          onKeyUp={handleTextChange}
        />
      )}
      <DataTable
        data-testid="searchable-table"
        description="Basic"
        rows={searchInput ? filteredRows : rows}
        columns={columns}
        isLoading={isLoading}
        idPrefix="basic"
        scroll
        style={{ maxHeight: '36rem', marginTop: '1.5rem' }}
      />
      {showSeeMoreBtn && (
        <div className="table-btnWrapper" data-testid="btn-see-more">
          <Button onClick={handleSeeMore} size="sm" secondary>
            See more
          </Button>
        </div>
      )}
    </>
  )
}

export default SearchableTableACDCNotCollapsed
